import { ReportStatus } from '../../apis/graphql/types';
import { Option } from '../../components/types';

export const ReportStatusVariables = {
  Complete: 'COMPLETE',
  Ready: 'READY',
  Processing: 'PROCESSING',
  Scheduled: 'SCHEDULED',
  Stopped: 'STOPPED',
  Failed: 'FAILED',
} as const;

export const REPORT_STATUS_OPTIONS: Option[] = [
  { value: ReportStatus.Ready, label: 'Ready' },
  { value: ReportStatus.Pending, label: 'Processing' },
  { value: ReportStatus.Scheduled, label: 'Scheduled' },
  { value: ReportStatus.Stopped, label: 'Stopped' },
  { value: ReportStatus.Complete, label: 'Complete' },
  { value: ReportStatus.Failed, label: 'Failed' },
];
